const styles = {
    container: {
        marginRight: 20
    },
    imageIcon:{
        backgroundColor: 'transparent',
        borderRadius: 0
    }
  };

  export default styles;



// WEBPACK FOOTER //
// ./src/containers/downloadButtons/styles/DownloadButtonsStyles.js